<template>
  <div>
    <form-container v-if="modelInfo.categoryId !== 'UNS'" id="transformer-package-container">
      <form-item-container class="transformer-package-item" label="データ変換選択">
        <field-container class="transformer-package-select">
          <div class="form-standard" @click="onClickSelectTransformerPackage">
            {{selectedTransformerPackage() ? selectedTransformerPackage().packageName : ''}}
          </div>
          <transformer-package-select v-if="transformerPackages != null && visibleTransformerPackageSelect"
                                      :transformer-packages="transformerPackages"
                                      :selected-transformer-package="modelInfo.transformerPackage"
                                      @close="visibleTransformerPackageSelect=false"
                                      @select="onSelectTransformerPackage"
          />
        </field-container>
      </form-item-container>
      <form-item-container label="詳細設定" annotation="* 不明な場合は設定を変更しなくて構いません">
        <field-container v-if="selectedTransformerPackage()" class="transformer-package-detail">
          <div class="form-standard" @click="onClickTransformerSetting">設定を変更</div>
          <!--<el-button type="default"  class="form-standard" @click="onClickTransformerSetting">詳細設定</el-button>-->
          <transformer-package-detail
                  v-if="visibleTransformerPackageDetail"
                  :visible="visibleTransformerPackageDetail"
                  :transformer-package="selectedTransformerPackage()"
                  :transformers="transformers"
                  @close="visibleTransformerPackageDetail=false"
                  @update="onUpdateTransformers"
          />
        </field-container>
      </form-item-container>
    </form-container>

    <form-container id="model-option-container">
      <form-item-container label="アルゴリズム選択">
        <field-container :class="{'is-disabled': modelInfo.categoryId === 'UNS' && $route.meta.trainType === 'update'}">
          <div class="form-standard algorithm-select" @click="onClickSelectAlgorithm">
            {{selectedAlgorithm ? selectedAlgorithm.algorithmName : ''}}
          </div>
          <algorithm-select v-if="algorithmsCategories != null && visibleAlgorithmSelect"
                            :algorithmsCategories="algorithmsCategories"
                            :selectedAlgorithmForInit="selectedAlgorithm"
                            @close="visibleAlgorithmSelect=false"
                            @select="onSelectAlgorithm">
          </algorithm-select>
        </field-container>
      </form-item-container>
      <form-item-container v-show="hyperParams && hyperParams.length > 0" label="オプションの自動選択"
                           annotation="* 適切な範囲で自動的に効果的なオプションが選択されます">
        <field-container>
          <field-radio-group v-model="optimizeParams" name="optimize_params" :options="optimizeParamsOptions"
                             @change="val => modelInfo.algorithm.optimizeParams = val"></field-radio-group>
        </field-container>
      </form-item-container>
      <form-item-container v-if="!optimizeParams && hyperParams && hyperParams.length > 0" label="オプション設定"
                           annotation="* 不明な場合は値を変更しなくて構いません">
        <hyper-params :hyperParams="hyperParams" :hyperParamSummaries="hyperParamSummaries"></hyper-params>
      </form-item-container>
    </form-container>

    <form-container v-if="aggregateAlgorithm.find(algorithm => algorithm=== modelInfo.algorithm.algorithmId)" id="aggregate-option-container">
      <form-item-container label="集計対象選択"
                           tip="モデルの作成結果に基づいてどのような分布になっているかの集計・可視化を行います。"
                           annotation="* 分析対象に指定されていないデータ項目のみ指定可能です">
        <field-container>
          <field-select name="type" v-model="modelInfo.yName"
                        :clearable="true" placeholder="-" noDataText="選択可能な項目がありません。"
          >
             <el-option v-for="column in modelInfo.xExcept" :key="column" :label="column" :value="column"></el-option>
          </field-select>
        </field-container>
      </form-item-container>
    </form-container>
  </div>
</template>

<script>
import { AlgorithmSummary } from '../../../defines/algorithm'
import CommonUtil from '../../../utils/common'
import BaseTrainView from './base'
import HyperParamsCmp from '../../../components/form/field/hyper-params.vue'
import AlgorithmSelectCmp from '../../../components/model/train/dialogs/algorithm-select.vue'
import { Transformer } from '../../../defines/transformer'
import TransformerPackageDetailCmp from '../../../components/model/train/dialogs/transformer-package-detail.vue'
import TransformerPackageSelectDialogCmp from '../../../components/model/train/dialogs/transformer-package-select.vue'

export default {
  name: 'ModelTrainOptionView',
  mixins: [BaseTrainView],
  components: {
    'hyper-params': HyperParamsCmp,
    'algorithm-select': AlgorithmSelectCmp,
    'transformer-package-select': TransformerPackageSelectDialogCmp,
    'transformer-package-detail': TransformerPackageDetailCmp
  },
  props: {},
  data () {
    return {
      // Algorithms
      algorithmsCategories: [],
      selectedAlgorithm: AlgorithmSummary,
      optimizeParams: true,
      optimizeParamsOptions: [
        {
          label: '自動選択しない', value: false
        }, {
          label: '自動選択する', value: true
        }],
      hyperParams: [],
      hyperParamSummaries: [],
      visibleAlgorithmSelect: false,
      aggregateAlgorithm: ['KMeansLearner'],
      // Transformers
      transformers: [],
      transformerPackages: [],
      visibleTransformerPackageDetail: false,
      visibleTransformerPackageSelect: false
    }
  },
  methods: {
    initialize () {
      this.initializeAlgorithm()
      this.initializeTransformer()
    },
    initializeAlgorithm () {
      this.optimizeParams = this.modelInfo.algorithm.optimizeParams
      this.getAlgorithms().then(algorithmsCategories => {
        let categoryId = this.modelInfo.categoryId
        this.getAlgorithmHyperParams(categoryId, this.modelInfo.algorithm.algorithmId).then(hyperParamSummaries => {
          this.algorithmsCategories = algorithmsCategories
          this.selectedAlgorithm = this.getAlgorithmSummary(this.modelInfo.algorithm.algorithmId)

          let hyperParams = []
          for (let hyperParamSummary of hyperParamSummaries) {
            hyperParams.push({
              hyperParamId: hyperParamSummary.hyperParamId,
              value: (['n_units_2', 'n_units_3'].indexOf(hyperParamSummary.hyperParamId) >= 0
                ? ''
                : hyperParamSummary.defaultVal)
            })
          }

          if (CommonUtil.isNotNull(this.modelInfo.algorithm.hyperParams)) {
            for (let hyperParam of this.modelInfo.algorithm.hyperParams) {
              for (let tmpHyperParam of hyperParams) {
                if (tmpHyperParam.hyperParamId === hyperParam.hyperParamId) {
                  tmpHyperParam.value = hyperParam.value
                }
              }
            }
          }

          this.modelInfo.algorithm.hyperParams = hyperParams
          this.hyperParamSummaries = hyperParamSummaries
          this.hyperParams = hyperParams
          this.$forceUpdate()
        })
      })
    },

    initializeTransformer () {
      this.getTransformers().then((transformerPackages) => {
        this.transformerPackages = transformerPackages
      }).then(() => {
        if (CommonUtil.isNull(this.modelInfo.transformerPackage)) {
          return this.getDefaultTransformerPackage().then((defaultPackage) => {
            this.modelInfo.transformerPackage = defaultPackage
          })
        }

      }).then(() => {
        this.$forceUpdate()
      })
    },

    onClickSelectAlgorithm () {
      if (this.modelInfo.categoryId === 'UNS' && this.$route.meta.trainType === 'update') {
        return
      }
      this.visibleAlgorithmSelect = true
    },

    onSelectAlgorithm (algorithm) {
      if (CommonUtil.isNotNull(this.selectedAlgorithm) && this.selectedAlgorithm.algorithmId ===
          algorithm.algorithmId) {
        return
      }
      const isAggregateAlgorithm = this.aggregateAlgorithm.find(algorithmName => algorithmName === algorithm.algorithmId)
      if (isAggregateAlgorithm && this.modelInfo.categoryId === 'UNS') {
        this.modelInfo.yName = null
      }

      this.optimizeParams = this.modelInfo.algorithm.optimizeParams = true
      this.selectedAlgorithm = algorithm
      this.getAlgorithmHyperParams(this.modelInfo.categoryId, algorithm.algorithmId).then(hyperParamSummaries => {
        let hyperParams = []
        for (let hyperParamSummary of hyperParamSummaries) {
          hyperParams.push({
            hyperParamId: hyperParamSummary.hyperParamId,
            value: (['n_units_2', 'n_units_3'].indexOf(hyperParamSummary.hyperParamId) >= 0
              ? ''
              : hyperParamSummary.defaultVal)
          })
        }

        this.modelInfo.algorithm.algorithmId = algorithm.algorithmId
        this.modelInfo.algorithm.hyperParams = hyperParams
        this.hyperParamSummaries = hyperParamSummaries
        this.hyperParams = hyperParams
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      })
    },

    selectedTransformerPackage () {
      if (CommonUtil.isEmpty(this.modelInfo.transformerPackage)) { return null }
      return this.transformerPackages.find(
        transformerPackage => this.modelInfo.transformerPackage.packageId === transformerPackage.packageId)
    },

    onClickPackage (packageId) {
      this.modelInfo.transformerPackage = this.transformerPackages.filter(
        transformersPackage => transformersPackage.packageId === packageId)[0]
      this.$forceUpdate()
    },

    onClickTransformerSetting () {
      // this is for edit hyper params view.
      if (CommonUtil.isEmpty(this.modelInfo.transformerPackage.transformers)) {
        this.modelInfo.transformerPackage.transformers = []
      }

      let transformers = []
      new Promise(resolve => {
        if (CommonUtil.isEmpty(this.modelInfo.transformerPackage.transformerIds)) {
          this.getTransformerPackage(this.modelInfo.transformerPackage.packageId).then(transformerPackage => {
            this.modelInfo.transformerPackage.transformerIds = transformerPackage.transformerIds
            this.modelInfo.transformerPackage.defaultOptions = transformerPackage.defaultOptions
            resolve()
          })
        } else {
          resolve()
        }
      }).then(() => {
        const existTransformers = this.modelInfo.transformerPackage.transformers

        this.modelInfo.transformerPackage.transformerIds.forEach(transformerId => {
          const existTransformer = existTransformers.find(
            existTransformer => existTransformer.transformerId === transformerId)
          const transformerSummary = this.getTransformerSummary(transformerId)

          let transformer = Transformer
          if (CommonUtil.isNotEmpty(existTransformer)) {
            transformer = existTransformer
          } else {
            // if not exist specific or all transformers of packages, add transformer
            transformer = {
              transformerId: transformerId,
              use: CommonUtil.isEmpty(existTransformers)
            }
          }

          transformers.push({
            transformer: transformer,
            summary: transformerSummary
          })
        })

        return this.loadTransformersHyperParams(transformers).then(() => {
          this.transformers = transformers
          this.transformers.forEach(transformer => {
            if (CommonUtil.isNotEmpty(transformer.transformer) &&
                CommonUtil.isUndefined(transformer.transformer.use)) {
              transformer.transformer.use = CommonUtil.isNotEmpty(transformer.transformer.hyperParams)
            }
          })

          this.visibleTransformerPackageDetail = true
          this.$forceUpdate()
        })
      })
    },

    loadTransformersHyperParams (transformers) {
      return new Promise((resolve) => {
        let transformerHyperParamPromises = []
        let transformerIds = transformers.map(transformer => transformer.summary.transformerId)
        transformerIds = transformerIds.filter((value, index, array) => array.slice(0, index).indexOf(value) < 0)
        for (let transformerId of transformerIds) {
          transformerHyperParamPromises.push(this.getTransformerHyperParams(transformerId))
        }
        if (CommonUtil.isNotEmpty(transformerHyperParamPromises)) {
          Promise.all(transformerHyperParamPromises).then(transformersHyperParamSummaries => {
            for (let i in transformerIds) {
              const index = Number(i)
              let transformerSummary = this.getTransformerSummary(transformerIds[index])
              transformerSummary.hyperParams = transformersHyperParamSummaries[index]
            }
            resolve()
          })
        } else {
          resolve()
        }
      })
    },

    onUpdateTransformers (transformers) {
      this.modelInfo.transformerPackage.transformers = transformers
    },

    onClickSelectTransformerPackage () {
      if (CommonUtil.isEmpty(this.modelInfo.transformerPackage) || this.modelInfo.categoryId === 'UNS') {
        return
      }
      this.visibleTransformerPackageSelect = true
    },

    onSelectTransformerPackage (transformerPackage) {
      this.modelInfo.transformerPackage = transformerPackage
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
  }
}

</script>

<style scoped>
  #transformer-package-container,
  #model-option-container,
  #aggregate-option-container {
    max-width: 1000px;
    padding: 24px 24px 0;
  }

  #transformer-package-container .transformer-package-select .form-standard,
  #transformer-package-container .transformer-package-detail .form-standard {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration-line: underline;
    color: #2456d4;
    cursor: pointer;
  }

  .algorithm-select {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration-line: underline;
    color: #2456d4;
    cursor: pointer;
  }

  .is-disabled .algorithm-select {
    cursor: not-allowed;
  }

</style>



// WEBPACK FOOTER //
// src/views/model/train/option.vue